import { Injectable } from '@angular/core';

@Injectable()
export class NxTabsetConfig {
  /** provides default navigation context class: 'tabs' or 'pills' */
  public type = 'tabs';
}
